<template>
    <div>
        <a-tabs class="row" hide-add type="card" @change="tabChange">
            <a-tab-pane v-for="groupitem in configgroups" :key="groupitem.groups" :tab="groupitem.title">
          
        <a-table :dataSource="orgconfigList" :rowKey="item => item.id" :loading="loading" :pagination="false"
                bordered>
               <!-- <a-table-column key="id" title="id" data-index="id"/> -->
                <a-table-column key="title" title="名字" data-index="title" />
             <!--   <a-table-column key="name" title="变量名" data-index="name" /> -->
             <!--   <a-table-column key="groups" title="分组" data-index="groups" /> -->
                <a-table-column key="tip" title="描述" data-index="tip" />
             <!--   <a-table-column key="type" title="字段类型" data-index="type" /> -->
                <a-table-column key="config_value" title="value" >
                    <template slot-scope="item">
                      <input  v-model="item.config_value"/>
                      <a-button @click="AuthconfigEditshow(item)" class="active_btn" size="small" type="dashed" shape="round">
                          更新
                      </a-button>
                    </template>
                    </a-table-column>
                    <a-table-column key="is_org_config" title="是否统一配置" >
                        <template slot-scope="item">
                          <a-switch v-model="item.is_org_config" @change="editChangeConfig(item)" />
                        </template>
                        </a-table-column>  
                <!-- <a-table-column key="active" title="操作">
                    <template slot-scope="item">
                       
                     
                    </template>
                    {{item}}
                </a-table-column> -->
            </a-table>
    
        
       </a-tab-pane>
       </a-tabs> 
       
    </div>
</template>

<script>
    export default {
        components: {},
        props: {
            itemdata: {},
            org_id:undefined,
        },
        data() {
            return {
                data: [],
                configgroups: [],
                pageinfo: {
                    total: 1,
                    current: 1,
                    pageSize: 12
                },
                orgconfigList:[],
                loading: false,
                visible: false,
                tabsActiveKey: '',
            };
        },
        mounted() {
            this.getConfigGroup();
        },
        methods: {
            /**
             * 获取分组情况
             */
            getConfigGroup() {

                this.$axios
                    .post("/api/BasicConfig/getGroups", {
                        pageinfo: {
                            pageSize: 9999
                        }
                    })
                    .then((res) => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.configgroups = res.data;
                            this.tabsActiveKey=this.configgroups[0].groups;
                             this.getAuthConfigList()
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            editChangeConfig(item)
            {
                this.$axios
                    .post("/api/OrgConfig/editChangeConfig", {
                        data:{
                            id:item.id,
                            org_id:this.org_id,
                            },
                    })
                    .then((res) => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                          this.$message.success("修改成功", '3', null);
                         }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
                },
            tabChange(val) {
                 
                  this.tabsActiveKey = val
                 this.getAuthConfigList() 
              },
              
            getAuthConfigList() {
                this.$axios
                    .post("/api/OrgConfig/getInfo", {
                        data:{
                            groups:this.tabsActiveKey,
                            org_id:this.org_id,
                            },
                        pageinfo:this.pageinfo
                    })
                    .then((res) => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.orgconfigList = res.data;
                            this.pageinfo=res.data.pageinfo;
                         }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            
            AuthconfigEditshow(item) {
                this.$axios
                    .post("/api/OrgConfig/editConfig", {
                        data:{
                            name:item.name,
                            config_value:item.config_value,
                            org_id:this.org_id,
                            },
                    })
                    .then((res) => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                          this.$message.success("修改成功", '3', null);
                         }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            
       
       
        },
    };
</script>
<style>
    .active_btn {
        margin-left: 5px;
    }
</style>
